import React, { useState } from 'react'
import './usuario.css'
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useUsers } from '../../context/usersContext';

const getInitials = (firstName, lastName) => {
  const first = (firstName || '').trim().charAt(0);
  const last = (lastName || '').trim().charAt(0);
  return `${first}${last}`.toUpperCase() || '?';
};

const STEPS = [
  { id: 1, label: 'Enviar código' },
  { id: 2, label: 'Verificar código' },
  { id: 3, label: 'Nova senha' },
];

const Usuario = () => {
  const { sendCode, checkCode, changePassword } = useUsers();
  const userData = JSON.parse(localStorage.getItem('user'));

  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const emailLocalPart = (userData?.email || '').split('@')[0];
  const attributesToAvoid = [userData?.first_name, userData?.last_name, userData?.username, emailLocalPart]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase())
    .filter((value) => value.length >= 3);

  const passwordRules = [
    { key: 'length', label: 'Mínimo de 8 caracteres', valid: newPassword.length >= 8 },
    {
      key: 'notNumeric',
      label: 'Não pode ser somente números',
      valid: newPassword.length > 0 && /\D/.test(newPassword),
    },
    {
      key: 'notSimilar',
      label: 'Não pode ser igual/parecida com seu nome, usuário ou email',
      valid: newPassword.length > 0 && !attributesToAvoid.some((attr) => newPassword.toLowerCase().includes(attr)),
    },
    {
      key: 'match',
      label: 'As senhas devem coincidir',
      valid: confirmNewPassword.length > 0 && newPassword === confirmNewPassword,
    },
  ];
  const isPasswordValid = passwordRules.every((rule) => rule.valid);

  const NAO_INFORMADO = 'Não informado';

  const profileFields = [
    { label: 'Matrícula', value: userData.registration },
    { label: 'CPF', value: userData.cpf },
    { label: 'Cargo', value: userData.role_name },
    { label: 'Vínculo', value: userData.employment_relationship },
    { label: 'Órgão', value: userData.agency_name },
    {
      label: 'Unidade(s)',
      value: Array.isArray(userData.units) && userData.units.length
        ? userData.units.map((unit) => unit.acronym || unit.name).join(', ')
        : userData.unit_name,
    },
  ].map((field) => ({ ...field, value: field.value || NAO_INFORMADO }));

  const accessGroups = Array.isArray(userData.groups) ? userData.groups : [];

  const handleSendCode = async () => {
    if (loading) return;
    setLoading(true);
    const success = await sendCode();
    setLoading(false);
    if (success) setStep(2);
  };

  const handleCheckCode = async () => {
    if (loading) return;
    setLoading(true);
    const success = await checkCode(code);
    setLoading(false);
    if (success) setStep(3);
  };

  const handleChangePassword = async () => {
    if (loading || !isPasswordValid) return;
    setLoading(true);
    const success = await changePassword(newPassword);
    setLoading(false);
    if (success) {
      setStep(1);
      setCode('');
      setNewPassword('');
      setConfirmNewPassword('');
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>

        <div className='content profile-hero'>
          <div className='profile-avatar'>
            {getInitials(userData.first_name, userData.last_name)}
          </div>
          <div className='profile-heading'>
            <h2>{`${userData.first_name} ${userData.last_name}`}</h2>
            <p className='profile-email'>{userData.email}</p>
            {accessGroups.length > 0 && (
              <div className='profile-badges'>
                {accessGroups.map((group) => (
                  <span key={group} className='blue-text profile-badge'>{group}</span>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className='content'>
          <h3 className='section-title'>Dados Pessoais</h3>
          <div className='profile-info-grid'>
            {profileFields.map((field) => (
              <div key={field.label} className='profile-info-item'>
                <span>{field.label}</span>
                <strong className={field.value === NAO_INFORMADO ? 'semDados' : ''}>{field.value}</strong>
              </div>
            ))}
          </div>
        </div>

        <div className='content password-card'>
          <h3 className='section-title'>Alterar Senha</h3>

          <div className='password-steps'>
            {STEPS.map((s) => (
              <div
                key={s.id}
                className={`password-step ${step === s.id ? 'active' : ''} ${step > s.id ? 'done' : ''}`}
              >
                <span className='password-step-circle'>{step > s.id ? '✓' : s.id}</span>
                <span className='password-step-label'>{s.label}</span>
              </div>
            ))}
          </div>

          {step === 1 && (
            <div className='password-step-content'>
              <p>O código de verificação será enviado para <strong>{userData.email}</strong></p>
              <button onClick={handleSendCode} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar código'}
              </button>
            </div>
          )}

          {step === 2 && (
            <div className='password-step-content'>
              <input
                id='code'
                type="text"
                placeholder="Digite código enviado por email"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              <button onClick={handleCheckCode} disabled={loading || !code}>
                {loading ? 'Validando...' : 'Verificar Código'}
              </button>
            </div>
          )}

          {step === 3 && (
            <div className='password-step-content'>
              <div className='password_input'>
                <input
                  id='newcode'
                  type={showPassword ? "text" : "password"}
                  placeholder="Nova Senha"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>

              <div className='password_input'>
                <input
                  id='password'
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirmar Nova Senha"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEyeSlash : faEye}
                  className="eye-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </div>

              <ul className='password-checklist'>
                {passwordRules.map((rule) => (
                  <li key={rule.key} className={rule.valid ? 'valid' : ''}>
                    <span className='password-checklist-icon'>{rule.valid ? '✓' : '•'}</span>
                    {rule.label}
                  </li>
                ))}
              </ul>

              <button onClick={handleChangePassword} disabled={loading || !isPasswordValid}>
                {loading ? 'Salvando...' : 'Salvar Nova Senha'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Usuario;
